import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISeoTag, ISeoTagState } from "./seotagModel";
import {
  getAllSeoTag,
  getSeoTagByID,
  createSeoTag,
  updateSeoTag,
  deleteSeoTag,
  seoTagActiveInactive,
} from "./seotag.service";

const initialState: ISeoTagState = {
  loading: false,
  error: "",
  SeoTagID: null,
  SeoTagList: [],
  SeoTagDetail: {
    PageName: "",
    PageUrl: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeleteSeoTagID: null,
};

const seotagSlice = createSlice({
  name: "seotag",
  initialState,
  reducers: {
    setSeoTagID: (state, action: PayloadAction<number | null>) => {
      state.SeoTagID = action.payload;
    },
    clearSeoTagID: (state) => {
      state.SeoTagID = null;
    },
    clearSeoTagDetails: (state) => {
      state.SeoTagDetail = initialState.SeoTagDetail;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.isDeleteModalOpen = true;
      state.DeleteSeoTagID = action.payload;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeleteSeoTagID = null;
    },
  },
  extraReducers: (builder) => {
    // Get All SeoTags
    builder.addCase(getAllSeoTag.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllSeoTag.fulfilled, (state, action) => {
      state.loading = false;
      state.SeoTagList = action.payload || [];
    });
    builder.addCase(getAllSeoTag.rejected, (state, action: any) => {
      state.loading = false;
      state.error = action.payload?.message || "Something went wrong";
    });

    // Get SeoTag By ID
    builder.addCase(getSeoTagByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getSeoTagByID.fulfilled, (state, action) => {
      state.loading = false;
      state.SeoTagDetail = action.payload;
    });
    builder.addCase(getSeoTagByID.rejected, (state, action: any) => {
      state.loading = false;
      state.error = action.payload?.message || "Something went wrong";
    });

    // Create SeoTag
    builder.addCase(createSeoTag.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createSeoTag.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createSeoTag.rejected, (state) => {
      state.loading = false;
    });

    // Update SeoTag
    builder.addCase(updateSeoTag.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateSeoTag.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateSeoTag.rejected, (state) => {
      state.loading = false;
    });

    // Delete SeoTag
    builder.addCase(deleteSeoTag.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteSeoTag.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSeoTag.rejected, (state) => {
      state.loading = false;
    });

    // Active/Inactive SeoTag
    builder.addCase(seoTagActiveInactive.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(seoTagActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(seoTagActiveInactive.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  setSeoTagID,
  clearSeoTagID,
  clearSeoTagDetails,
  openDeleteModal,
  closeDeleteModal,
} = seotagSlice.actions;

export default seotagSlice.reducer;
